import {
  Add,
  Delete,
  EditOutlined,
  Groups,
  InfoOutlined,
} from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Box,
  ButtonGroup,
  Chip,
  ClickAwayListener,
  Fab,
  Grow,
  Icon,
  lighten,
  Link as MuiLink,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import React, { useState } from 'react';

import { BackButton } from '@/ui/components/button/BackButton';
import { BackToTopButton } from '@/ui/components/button/BackToTopButton';
import { CloseButton } from '@/ui/components/button/CloseButton';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { FSToggleButtonGroup } from '@/ui/components/button/FSToggleButtonGroup';
import { FSCard } from '@/ui/components/FSCard';
import { FSLink } from '@/ui/components/FSLink';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { Fonts } from '@/ui/theme/fonts';

export function ComponentsShowcase() {
  return (
    <div>
      <Stack alignItems={'start'}>
        <p>card :</p>
        <FSCard>Card with content - blabla</FSCard>
        <FSCard variant="elevation">
          Card with content - variant elevationn
        </FSCard>
        <p>normal :</p>
        <FSPrimaryButton>Primary Button</FSPrimaryButton>
        <FSPrimaryButton variant="outlined">
          Primary Button variant=outlined
        </FSPrimaryButton>
        <FSSecondaryButton>Secondary Button</FSSecondaryButton>
        <p>disabled :</p>
        <FSPrimaryButton disabled>Primary Button</FSPrimaryButton>
        <FSPrimaryButton variant="outlined" disabled>
          Primary Button variant=outlined disabled
        </FSPrimaryButton>
        <FSSecondaryButton disabled>Secondary Button</FSSecondaryButton>
        <Stack direction="row" gap={2}>
          <Stack direction="column" gap={2}>
            <p>other color (primary) :</p>
            <FSPrimaryButton color="info">info</FSPrimaryButton>
            <FSPrimaryButton color="error">error</FSPrimaryButton>
            <FSPrimaryButton color="primary">primary</FSPrimaryButton>
            <FSPrimaryButton color="secondary">secondary</FSPrimaryButton>
            <FSPrimaryButton color="success">success</FSPrimaryButton>
            <FSPrimaryButton color="warning">warning</FSPrimaryButton>
            <FSPrimaryButton color="inherit">inherit</FSPrimaryButton>
            <FSPrimaryButton
              sx={{
                backgroundColor: '#088',
                color: '#FFFFFF',
                '&:hover': {
                  backgroundColor: '#066',
                },
              }}
            >
              custom
            </FSPrimaryButton>
          </Stack>
          <Stack direction="column" gap={2}>
            <p>other color (primary outlined) :</p>
            <FSPrimaryButton variant="outlined" color="info">
              info
            </FSPrimaryButton>
            <FSPrimaryButton variant="outlined" color="error">
              error
            </FSPrimaryButton>
            <FSPrimaryButton variant="outlined" color="primary">
              primary
            </FSPrimaryButton>
            <FSPrimaryButton variant="outlined" color="secondary">
              secondary
            </FSPrimaryButton>
            <FSPrimaryButton variant="outlined" color="success">
              success
            </FSPrimaryButton>
            <FSPrimaryButton variant="outlined" color="warning">
              warning
            </FSPrimaryButton>
            <FSPrimaryButton variant="outlined" color="inherit">
              inherit
            </FSPrimaryButton>
            <FSPrimaryButton
              variant="outlined"
              sx={{
                color: '#088', // text color
                borderColor: '#088',
                '&:hover': {
                  backgroundColor: '#08820a0', // optional light hover background
                  borderColor: '#066', // darker border on hover
                },
              }}
            >
              custom
            </FSPrimaryButton>
          </Stack>
          <Stack direction="column" gap={2}>
            <p>other color (secondary) :</p>
            <FSSecondaryButton color="info">info</FSSecondaryButton>
            <FSSecondaryButton color="error">error</FSSecondaryButton>
            <FSSecondaryButton color="primary">primary</FSSecondaryButton>
            <FSSecondaryButton color="secondary">secondary</FSSecondaryButton>
            <FSSecondaryButton color="success">success</FSSecondaryButton>
            <FSSecondaryButton color="warning">warning</FSSecondaryButton>
            <FSSecondaryButton color="inherit">inherit</FSSecondaryButton>
            <FSSecondaryButton
              sx={{
                color: '#088', // text color
                '&:hover': {
                  backgroundColor: '#08820a0', // optional light hover
                },
              }}
            >
              custom
            </FSSecondaryButton>
          </Stack>
        </Stack>
        <p>icons (size + font) : </p>
        <EditOutlined />
        <EditOutlined sx={{ fontSize: 12 }} />
        <EditOutlined sx={{ fontSize: 40 }} />
        <EditOutlined sx={{ color: '#AA3344' }} />
        <EditOutlined sx={{ color: '#AA3344' }} />
        <Icon baseClassName="fas" className="fa-plus-circle" />
        <p>tooltip :</p>
        <Tooltip title={'Tooltip on icon'}>
          <InfoOutlined />
        </Tooltip>
        <Tooltip title={'Bottom tooltip on button'} placement="right">
          {/* hack: box is used to make tooltip visible */}
          <Box>
            <FSPrimaryButton startIcon={<Groups />}>
              {'button with tooltip'}
            </FSPrimaryButton>
          </Box>
        </Tooltip>
        <p>badge :</p>
        {/* <Badge color="secondary" badgeContent=" "> */}
        <Badge color="primary" badgeContent="3">
          <FSPrimaryButton>Button with badge</FSPrimaryButton>
        </Badge>
        <Badge color="primary" badgeContent="3">
          <FSPrimaryButton color="info">Button with badge</FSPrimaryButton>
        </Badge>
        <Badge color="secondary" badgeContent="3">
          <FSPrimaryButton color="info">Button with badge</FSPrimaryButton>
        </Badge>
        <Badge color="error" badgeContent="3">
          <FSSecondaryButton>Button with badge</FSSecondaryButton>
        </Badge>
        <p>links :</p>
        <LinkElements />
        <p>toggle :</p>
        <ToggleButtons />
        <p>split button :</p>
        <SplitButton />
        <p>other : </p>
        <CloseButton />
        <BackButton text="back button" onClick={() => {}} />
        <BackToTopButton />
        fab add button for on tour
        <FabAddButton />
      </Stack>
      <p>typography :</p>
      <p>
        MUI note : default typography configuration relies only on the 300, 400,
        500, and 700 font weights
      </p>
      <Typography sx={{ fontSize: '30px' }}>number 12345</Typography>
      <Typography sx={{ fontSize: '30px' }}>Typography</Typography>
      <Typography sx={{ fontSize: '30px', fontWeight: 'light' }}>
        Typography fontWeight: light
      </Typography>
      <Typography sx={{ fontSize: '30px', fontWeight: 'normal' }}>
        Typography fontWeight: normal
      </Typography>
      <Typography sx={{ fontSize: '30px', fontWeight: 'bold' }}>
        Typography fontWeight: bold
      </Typography>
      <Typography sx={{ fontSize: '30px', fontWeight: '200' }}>
        Typography fontWeight: 200
      </Typography>
      <Typography sx={{ fontSize: '30px', fontWeight: '800' }}>
        Typography fontWeight: 800
      </Typography>
      <Typography sx={{ fontSize: '30px', fontWeight: '900' }}>
        Typography fontWeight: 900
      </Typography>
      <p>🍝 explicit fonts :</p>
      <Typography sx={{ fontSize: '30px', fontFamily: Fonts.DarkerGrotesque }}>
        fontFamily: Fonts.DarkerGrotesque 123 44 2.3 0% E
      </Typography>
      <Typography sx={{ fontSize: '30px', fontFamily: Fonts.Urbanist }}>
        fontFamily: Fonts.Urbanist 123 44 2.3 0% E
      </Typography>
      <p>chip : text in color box</p>
      <Stack sx={{ flexDirection: 'row', gap: 2, mb: 2 }}>
        <Chip label="label" />
        <Chip label="small" size="small" />
        <Chip icon={<Add />} label={'chip with icon'} />
        <Chip label="Chip Outlined" variant="outlined" />
        <Chip label="Clickable" onClick={() => {}} />
        <Chip label="Deletable" onDelete={() => {}} />
        <Chip
          label="Custom delete icon"
          onClick={() => {}}
          onDelete={() => {}}
          deleteIcon={<Delete />}
        />
      </Stack>
      <Stack sx={{ flexDirection: 'row', gap: 2, mb: 2 }}>
        <Chip avatar={<Avatar>M</Avatar>} label="Avatar" />
        <Chip label="primary" color="primary" />
        <Chip label="success" color="success" />
        <Chip label="primary" color="primary" variant="outlined" />
        <Chip label="success" color="success" variant="outlined" />
        <Chip
          label="custom color"
          sx={{ backgroundColor: '#088', color: '#fff' }}
        />
      </Stack>
      <Stack sx={{ flexDirection: 'row', gap: 2, mb: 2 }}>
        <Chip
          label={'outlined border color custom'}
          size="small"
          variant="outlined"
          sx={{
            borderColor: ColorsRaw.main.Navy_Light,
            fontWeight: 'bold',
            fontSize: '1.1rem',
          }}
        />
      </Stack>
    </div>
  );
}

function FabAddButton() {
  const textColor = ColorsRaw.basic.White;
  const bgColor = ColorsRaw.anthracite.Anthracite_4;
  const hoverBgColor = lighten(bgColor, 0.2);
  return (
    <Fab
      size="small"
      sx={{
        bgcolor: bgColor,
        color: textColor,
        '&:hover': { bgcolor: hoverBgColor },
      }}
    >
      <Add />
    </Fab>
  );
}

function SplitButton() {
  const options = [
    'Partager',
    'Partager section mobilité',
    'Partager section restauration',
    'Partager section hébergement',
  ];
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef}>
        <FSPrimaryButton onClick={handleClick}>
          {options[selectedIndex]}
        </FSPrimaryButton>
        <FSPrimaryButton onClick={handleToggle} sx={{ p: 0 }}>
          <ArrowDropDownIcon />
        </FSPrimaryButton>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

function ToggleButtons() {
  const [toggleValueId, setToggleValueId] = useState('item3');
  const toggleValues = [
    { id: 'team', value: 'Equipe' },
    { id: 'artist', value: 'Artiste' },
    { id: 'item3', value: 'item3' },
  ];
  const toggleValuesComponents = [
    {
      id: 'team',
      value: (
        <Box sx={{ backgroundColor: '#353', padding: 0.5, borderRadius: 5 }}>
          <Typography>Equipe</Typography>
        </Box>
      ),
    },
    {
      id: 'artist',
      value: (
        <Typography sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
          Artiste
        </Typography>
      ),
    },
    { id: 'item3', value: 'item3' },
  ];
  return (
    <>
      <FSToggleButtonGroup
        selectedValueId={toggleValueId}
        values={toggleValues}
        onChange={(value) => setToggleValueId(value)}
      />
      <FSToggleButtonGroup
        selectedValueId={toggleValueId}
        values={toggleValuesComponents}
        onChange={(value) => setToggleValueId(value)}
      />
    </>
  );
}

function LinkElements() {
  return (
    <ul>
      <li>
        -a- tag link <a>link</a> no href
      </li>
      <li>
        -a- tag link <a href="#">link</a>
      </li>
      <li>
        <MuiLink href="#">mui link</MuiLink>
      </li>
      <li>
        <FSLink>fs-link</FSLink> - no ref
      </li>
      <li>
        <FSLink href={'#'}>fs-link</FSLink>
      </li>
      <li>
        <FSLink href={'#'} underline="always">
          fs-link
        </FSLink>{' '}
        - underline always
      </li>
      <li>
        <FSLink href={'#'} underline="none">
          fs-link
        </FSLink>{' '}
        - underline none
      </li>
      <li>
        <FSLink href={'#'} underline="hover">
          fs-link
        </FSLink>{' '}
        - underline hover
      </li>
      <li>
        <FSLink href={'#'} target="_blank">
          fs-link
        </FSLink>{' '}
        - target= _blank - open in new window
      </li>
      <li>
        <FSCard variant="elevation">
          Link on element with background <FSLink href={'#'}>fs-link</FSLink>
        </FSCard>
      </li>
      <li>
        <FSLink href={'#'} color={'secondary'}>
          fs-link
        </FSLink>{' '}
        - color secondary
      </li>
      <li>
        <FSLink href={'#'} color={'inherit'}>
          fs-link
        </FSLink>{' '}
        - color inherit
      </li>
      <li>
        <FSLink href={'#'} color={'#4AAA32'}>
          fs-link
        </FSLink>{' '}
        - color #4AAA32
      </li>
      <li>
        <FSLink href={'#'} variant="body1">
          fs-link
        </FSLink>{' '}
        - variant body1
      </li>
      <li>
        <FSLink href={'#'} variant="body2">
          fs-link
        </FSLink>{' '}
        - variant body2
      </li>
      <li>
        <FSLink href={'#'} variant="h6">
          fs-link
        </FSLink>{' '}
        - variant h6
      </li>
      <li>
        <FSLink href={'#'} variant="caption">
          fs-link
        </FSLink>{' '}
        - variant caption
      </li>
      <li>
        <FSLink href={'#'} variant="subtitle1">
          fs-link
        </FSLink>{' '}
        - variant subtitle1
      </li>
      <li>
        <FSLink href={'#'} variant="overline">
          fs-link
        </FSLink>{' '}
        - variant overline
      </li>
    </ul>
  );
}
